import React from 'react'
import {
  Card,
  CardContent,
  Grid,
  Typography,
  CardActions,
  useMediaQuery,
  useTheme
} from '@mui/material'
import MyButton from '../../../components/ui/MyButton'
import { useFormikContext } from 'formik'

const ProfileTeacherPage1 = ({ nextPage, profileTeacher }) => {
  const theme = useTheme()
  const matchesMD = useMediaQuery(theme.breakpoints.up('md'))

  const { setFieldValue } = useFormikContext()

  const handleChooseCommunity = () => {
    setFieldValue('typeOfTeacher', 'commutor')
    setFieldValue('degreeImages', [])
    setFieldValue('selectedDegreeImages', [])
    setFieldValue('expImages', [])
    setFieldValue('selectedExpImages', [])
    nextPage()
  }

  const handleChooseProfessional = () => {
    setFieldValue('typeOfTeacher', 'professional')
    if (profileTeacher) {
      setFieldValue('degreeImages', profileTeacher.degreeImages)
    }
    setFieldValue('selectedDegreeImages', [])

    if (profileTeacher) {
      setFieldValue('expImages', profileTeacher.expImages)
    }
    setFieldValue('selectedExpImages', [])
    nextPage()
  }

  return (
    <Grid item container alignItems="center" justifyContent="center" directon="column" spacing={3}>
      <Grid item>
        <Typography
          gutterBottom
          style={{
            textTransform: 'uppercase',
            fontWeight: 600,
            textAlign: 'center',
          }}
          variant={matchesMD ? 'h4' : 'h5'}
        >
          Choose a type of teacher
        </Typography>
      </Grid>
      <Grid
        item
        container
        justifyContent='space-around'
      >
        <Grid
          md={5}
          item
          component={Card}
          sx={{ marginBottom: { xs: '2em', md: '0' } }}
        >
          <CardContent>
            <Typography
              variant="h5"
              component="h2"
              style={{
                textTransform: 'uppercase',
                textAlign: 'center',
              }}
            >
              Professional teacher
            </Typography>
            <h4>* Benefits:</h4>
            <ul>
              <li>
                Your profile is displayed as a professional teacher, increase
                credibility.
              </li>
            </ul>
            <h4>* Requirements:</h4>
            <ul>
              <li>
                Provide us your scanned images of teaching certificates and
                teaching experiences.
              </li>
              <li>A introduction video of 1 - 5 minutes of length.</li>
            </ul>
          </CardContent>
          <CardActions>
            <div
              style={{ width: '100%', textAlign: 'center' }}
            >
              <MyButton onClick={handleChooseProfessional}>Choose</MyButton>
            </div>
          </CardActions>
        </Grid>

        <Grid
          md={5}
          item
          component={Card}
        >
          <CardContent>
            <div style={{ textAlign: 'center' }}>
              <Typography
                variant="h5"
                component="h2"
                style={{ textTransform: 'uppercase' }}
              >
                Community Tutor
              </Typography>
            </div>
            <h4>* Benefits:</h4>
            <ul>
              <li>Your profile is displayed as a community tutor.</li>
            </ul>
            <h4>* Requirements:</h4>
            <ul>
              <li>A introduction video of 1 - 5 minutes of length.</li>
            </ul>
          </CardContent>
          <CardActions>
            <div
              style={{ width: '100%', textAlign: 'center' }}
            >
              <MyButton onClick={handleChooseCommunity}>Choose</MyButton>
            </div>
          </CardActions>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ProfileTeacherPage1
